module.exports = __webpack_public_path__ + "static/media/one_playground_logo_black_1.77c19473.png";